import STBoardComments from "../../../assets/styles/organisms/boardComment.module.scss";
import CommentsList from "./CommentList";
import CommentsHeader from "./CommentsHeader";
import CommentsLoading from "./CommentsLoading";
import CreateNewParentComment from "./CommentForm";
import LoadMoreButton from "./LoadMoreButton";
import { useGetRootComments } from "./hooks";
import { useWebsocket } from "./Websocket";
import CommentSnackbar from "./CommentSnackbar";

const Comments = () => {
  const { isCommentLoading } = useGetRootComments();
  useWebsocket();

  if (isCommentLoading) {
    return <CommentsLoading />;
  }

  return (
    <div className={`${STBoardComments.comment} ${STBoardComments.wrapper}`}>
      <CommentsHeader />
      <CreateNewParentComment />
      <CommentsList />
      <LoadMoreButton />
      <CommentSnackbar />
    </div>
  );
};

export default Comments;
